import { useContext, useEffect, useRef } from 'react';
import { ServicesContext } from 'app/items/shared/context_interface';
import classNames from 'classnames';

export function CesiumAttribution({ className }: { className?: string }) {
    const { cesiumMap } = useContext(ServicesContext);
    const credits = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!credits.current) return;
        cesiumMap.appendCredits(credits.current);
    }, [cesiumMap]);

    return (
        <div
            className={classNames('CesiumAttribution', className, 'display-over-map')}
            id="credit-container"
            ref={credits}
        />
    );
}
